import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { FeatureProvider } from './contexts/FeatureContext';
import { ToastProvider } from './contexts/ToastContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import ToastContainer from './components/common/Toast';
import LandingPage from './pages/LandingPage';
import AppShell from './components/layout/AppShell';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <FeatureProvider>
        <ToastProvider>
          <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/app/*" element={<AppShell />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
          <ToastContainer />
        </ToastProvider>
        </FeatureProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
